import LeaderCard from './LeaderCard'

export default LeaderCard
